/*
** 스크립트 정의
*/
const categorySidebarModule = {
  init: function() {
    const _ = this;
    document.addEventListener('DOMContentLoaded', () => {
      // _.set_post_counts();
      // _.get_post_counts_parse();
      // _.set_current_menu();
    });
    _.set_current_menu();
    _.set_family_menu();
  },
  set_post_counts: function () {
    const categories = document.querySelectorAll('.wp-block-categories .cat-item');
    categories.forEach(category => {
      
      // 텍스트 노드를 배열로 변환
      const items = Array.from(category.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
      const counts = this.get_post_counts_parse(
        Array.isArray(items)
          ? items.map(textNode => textNode.textContent)
          : []
      );
      items.forEach(textNode => category.removeChild(textNode));

      // 숫자가 있다면 디자인
      if (counts && counts != '0') {
        const link = category.querySelector('a');
        if (link) {
          link.insertAdjacentHTML('beforeend', `<span class="cat-item-post-counts">${counts}</span>`);
        }
      }

    });
  },
  get_post_counts_parse: function (textNodes) {

    if (!textNodes) {
      return '0';
    }

    // 각 문자열에서 숫자만 추출하여 새로운 배열 생성
    const numbers = textNodes.map(text => {
      const match = text.match(/\((\d+)\)/); // 정규표현식 사용
      return match ? match[1] : null; // 매칭된 숫자 반환, 매칭되지 않으면 null 반환
    }).filter(number => number !== null); // null 값을 필터링하여 제거
    return numbers.toString();

  },
  set_current_menu: function () {
    // 현재 요소를 기준으로 상위 요소를 찾아 특정 클래스를 배열로 반환하는 함수
    function findParentsWithClass(element, className) {
      const parentsWithClass = [];
      let parent = element.parentElement;
      while (parent) {
        if (parent.classList.contains(className)) {
          parentsWithClass.push(parent);
        }
        parent = parent.parentElement;
      }
      return parentsWithClass;
    }
    /**
     * 활성화 방해 요소를 제거해주자.
     * @returns 
     */
    function get_less_pagepath() {
      let pathname = window.location.pathname;
      pathname = pathname.replace(/\/page\/\d+\//, '/');
      return pathname;
    }
    const links = document.querySelectorAll('.wp-block-navigation-item__content');
    const pathname = get_less_pagepath();
    links.forEach(link => {
      let href = (link.getAttribute('href') || '');
      href = href.includes(window.location.origin) ? href.replace(/^https?:\/\/[^\/]+/, '') : href ;
      href = href.replaceAll('/#', '/');
      if (decodeURIComponent(pathname) === decodeURIComponent(href)) {
        // link.classList.add('wp-block-navigation-current-item');
        const parents = findParentsWithClass(link, 'wp-block-navigation-item');
        parents.forEach(element => {
          element.classList.add('wp-block-navigation-current-item');
        });
      }
    });
    const navs = document.querySelectorAll('.wp-block-navigation-item__content');
    navs.forEach(nav => {
      let href = (nav.getAttribute('href') || '');
      let target = (nav.getAttribute('target') || '');
      href = href.replace(/^https?:\/\/[^\/]+/, '');
      href = href.replaceAll('/#', '/');
      if (pathname === href && (!target || ['_self', '_parent' ,'_top'].includes(target))) {
        nav.style.fontWeight = 'bold';
        // nav.classList.add('wp-block-navigation-current-item');
        const parents = findParentsWithClass(nav, 'wp-block-navigation-item');
        parents.forEach(element => {
          const current = Array.from(element.children).find(child => child.classList.contains('wp-block-navigation-item__content'));
          if (current) {
            current.style.fontWeight = 'bold';
          }
        });
      }
    });
  },
  set_family_menu: function () {

    let getSiblings = function (e) {
      // for collecting siblings
      let siblings = []; 
      // if no parent, return no sibling
      if(!e.parentNode) {
          return siblings;
      }
      // first child of the parent node
      let sibling  = e.parentNode.firstChild;
      
      // collecting siblings
      while (sibling) {
          if (sibling.nodeType === 1 /* && sibling !== e */ ) {
              siblings.push(sibling);
          }
          sibling = sibling.nextSibling;
      }
      return siblings;
    };

    const families = document.querySelectorAll('.wp-block-categories-list-family');
    families.forEach((container) => {

      const current = container.querySelector('.current-cat');
      if (current) {
        const child = current.querySelectorAll('& > .children > .cat-item');
        

        // let prev = null;
        // if (parent) {
        //   prev = parent.cloneNode();
        //   const parentChild = prev.querySelector(':scope > .children');
        //   if (parentChild) {
        //     parentChild.remove();
        //   }
        // }

        // console.log(parent, '== parent ==')
        // console.log(current, '== current ==')
        // console.log(prev, '== prev ==')

        if (child.length) {

          const removeChild = current.querySelector(':scope > .children');
          if (removeChild) {
            removeChild.remove();
          }

          container.innerHTML = '';
          container.appendChild(current);
          child.forEach(node => {
            const clonedNode = node.cloneNode(true); // 노드를 복제합니다.
            container.appendChild(clonedNode); // 복제한 노드를 추가합니다.
          });

        } else {

          container.innerHTML = '';
          const parent = current.parentElement ? current.parentElement.closest('.cat-item') : null ;
          if (parent) {
            const removeChild = parent.querySelector(':scope > .children');
            if (removeChild) removeChild.remove();
            parent.classList.remove('current-cat-parent');
            parent.classList.remove('current-cat-ancestor');
            container.appendChild(parent);
          }

          const siblins = getSiblings(current);
          siblins.forEach(node => {
            const clonedNode = node.cloneNode(true); // 노드를 복제합니다.
            container.appendChild(clonedNode); // 복제한 노드를 추가합니다.
          });

        }
      }

      // 마크업 종료
      container.classList.add('wp-block-categories-list-family-initialized');

    });

  }
};
categorySidebarModule.init();